import React, { useState } from 'react';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isMobile} from 'react-device-detect';
import ButtonBase from '../../../../Buttons/ButtonBase';
import { TextField } from '@material-ui/core';
import MaskedInput from 'react-text-mask';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import axios from 'axios';
import { addCard } from "../../../../../store/actions/UserAction"

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    width: 592,
    height: 592,
    borderRadius: 4,
    padding: 24,
    margin:0,
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    position: 'relative',
    '&:focus': {
      outline: 'none',
    },
    '@media(max-width: 592px)' : {
      width: 328,
      height: 'auto'
    }
  },
  formContent : {
    maxWidth: 368,
    '@media(max-width: 592px)' : {
      maxWidth: 286
    }
  },
  infoWrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
  },
  name: {
    fontSize: 28,
    color: '#10587f',
    textAlign: 'center',
    marginTop: isMobile ? 0 : 15,
    marginBottom: 21,
    fontWeight: 'bold',
  },
  subname: {
    fontSize: 16,
    color: '#484848',
    textAlign: 'center',
    margin: '0 0 21px 0',
    maxWidth: isMobile ? 264 : 311,
  },
  twoInputs: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: isMobile? 0 : 20,
  },
  ButtonBase: {
    minWidth: isMobile ? '144px !important' : '160px !important',
    width: 'initial',
  },
  buttonCancel: {
    marginRight: 32,
    '@media(max-width: 592px)' : {
      marginRight: 8
    }
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },
  TextField: {
    maxWidth: 448,
    '@media(max-width: 592px)' : {
      width: 286,
      height: 'auto'
    }
  },
  TextField_small: {
    maxWidth: '46%',
  },
  text : {
    fontSize: 12,
    borderTop: '1px solid #e7e7e7',
    maxWidth: 369,
    padding: '8px 20px 50px',
    textAlign: 'center',
    '@media(max-width: 592px)' : {
      padding: '8px 20px 30px'
    }
  },
  link: {
    color: '#10587f',
    fontWeight: 'bold',
    textDecoration: 'none'
  }
});

function MethodPayModal({
  open,
  handleClose,billing,addCard
}) {
  const [focus, setFocusData] = useState();

  const classes = useStyles();

  const closeModal = (event) => {
    event.preventDefault();
    handleClose();
    
  };

  const formBillingValues = {
    name: '',
    number: '',
    expiry: '',
    cvc: '',
  };

  const handleInputFocus = (e) => {
    setFocusData(e.target.name);
  };

  
  const handleSubmitBillingPaymentForm = async (
    values,{ setFieldError, resetForm }) => {
  console.log('values ', values);
    const [month, year,] = values.expiry.split('/');

    let info ={
    
            "number":values.number,
            "name":values.name,
            "month": month,
            "year": `20${year}` ,
            "cvc": values.cvc,
            "currency":"mxn",
            "country":"México"
        
    }
    addCard(info, billing)
      .then(res=>{
        console.log(res)
        handleClose();
      })
      .catch(err =>  {
        console.log(err)
        setFieldError('number', err);
      }); 
  }

  const handleRenderPaymentForm = (props) => {
    const {
      handleChange,
      handleSubmit,
      values,
      touched,
      errors,
      handleBlur,
      isValid,
    } = props;

    return (
      <form className={classes.formContent} autocomplete="off">
        <TextField
          label="Nombre titular de tarjeta"
          name="name"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          value={values.name}
          onChange={handleChange}
          helperText={touched.name && errors.name ? errors.name : ''}
          error={touched.name && errors.name ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
          onFocus={handleInputFocus}
        />
        <TextField
          label="Número de tarjeta"
          name="number"
          type="text"
          variant="outlined"
          value={values.number}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
          }}
          inputProps={{ maxLength: 16 }}
          onBlur={handleBlur}
          onChange={handleChange}
          helperText={touched.number && errors.number ? errors.number : ''}
          error={touched.number && errors.number ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
          onFocus={handleInputFocus}
        />
        <div className={classes.twoInputs}>
          <MaskedInput
            name="expiry"
            value={values.expiry}
            className="inputMask"
            placeholder="MM/YY"
            onBlur={handleBlur}
            onChange={handleChange}
            mask={[/[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/]}
            onFocus={handleInputFocus}
          />

          <TextField
            label="CVV"
            name="cvc"
            type="text"
            variant="outlined"
            value={values.cvc}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }}
            inputProps={{ maxLength: 4 }}
            onBlur={handleBlur}
            onChange={handleChange}
            helperText={touched.cvc && errors.cvc ? errors.cvc : ''}
            error={touched.cvc && errors.cvc ? true : false}
            fullWidth
            classes={{ root: classes.TextField }}
            onFocus={handleInputFocus}
          />
        </div>

          <p className={classes.text}>
            Contacta Abogado@ te cobrará de forma automática y mensual hasta que
            canceles tu suscripción. Las condiciones completas del servicio
            están disponibles <a href="/informacion-adicional" target="_blank" className={classes.link}>aquí</a>.
          </p>

        <div className={classes.buttons}>
          <ButtonBase
            onClick={closeModal}
            variant="primaryOutlined"
            className={`${classes.ButtonBase} ${classes.buttonCancel}`}
          >
            Cancelar
          </ButtonBase>

          <ButtonBase
            type="submit"
            onClick={handleSubmit}
            variant="primary"
            className={classes.ButtonBase}
          >
            Guardar
          </ButtonBase>
        </div>
      </form>
    );
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      
    >
      <Fade in={open}>
        <div className={classes.paper}>
          {/* <img src='/img/icons/close.svg' alt='cerrar mensaje' className={classes.closeIcon} onClick={handleClose} /> */}
          <div className={classes.infoWrapper}>
            <div>
              <p className={classes.name}>Agregar nuevo método de pago</p>
            </div>

            <div className={classes.subname}>
              <span>Tarjeta de crédito o débito</span>
            </div>

            <Formik
              initialValues={formBillingValues}
               
               onSubmit={handleSubmitBillingPaymentForm}
              render={handleRenderPaymentForm}
            />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => ({
  addCard:(card, billing) => dispatch( addCard(card, billing))
});

const mapStateToProps = (state) => ({
  laywerUid: state.authClient.uid,
  modalPayments: state.ModalReducer.openModalPayments,
  role: state.authClient.role,
  billing: state.billingReducer.billingData,
});

export default connect(mapStateToProps, mapDispatchToProps)(MethodPayModal);
